import { SelectStoreResponse } from './types';

export const STORE_LOCATION_COOKIE = 'STORE_LOCATION_COOKIE';
export const CART_IMPORT_FLOW = 'CART_IMPORT_FLOW';
export const SUCCESS = 'success';
export const ERROR = 'error';
export const IDLE = 'idle';
export const SELECT_STORE_INITIAL_STATE: SelectStoreResponse = {
  message: IDLE,
  url: '',
  errorCode: ''
};
export const CART_FLOW = 'CART_FLOW';
export const CART_IMPORT_ERROR = 'CART_IMPORT_ERROR';

export const FAULTINJECT_SELECT_STORE = 'faultInject_selectStore';
export const FAULTINJECT_SELECT_STORE_VALUE = 'value_1';
